import dayjs, { Dayjs } from 'dayjs'

export const getEndOfDay = (dateTime: Dayjs | number | string): Dayjs => {
  const date = dayjs(dateTime)
  const endOfDay = dayjs(date.toDate().setHours(23, 59, 59, 0))
  return endOfDay
}
